module.exports = __webpack_public_path__ + "assets/icons/icon_signal4.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/icon_signal4.svg
// module id = NAwI
// module chunks = 1